import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Logo from "@/components/site/Logo";

const NAV = [
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/industries", label: "Industries" },
  { to: "/approach", label: "Approach" },
  { to: "/insights", label: "Insights" },
];

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#121312] text-[#E4E5DF] mt-24 overflow-hidden saafi-grain"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-24 pb-10 relative">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-10">
          <div className="md:col-span-7">
            <Logo variant="light" />
            <p className="mt-8 text-[15px] leading-relaxed text-[#9FA498] max-w-md">
              A consulting and investment firm partnering with companies,
              investors and institutions to design, build and scale solutions
              that are commercially viable and environmentally responsible.
            </p>
            <div className="mt-10 flex items-center gap-2 font-mono-alt text-[11px] uppercase tracking-[0.25em] text-[#79836B]">
              <span className="inline-block w-2 h-2 bg-[#A3C940]" />
              Estd. 2022 · India
            </div>
          </div>

          <div className="md:col-span-5">
            <p className="text-[11px] uppercase tracking-[0.25em] text-[#79836B] mb-6">
              Navigate
            </p>
            <ul className="flex flex-wrap items-center gap-x-8 gap-y-3 text-[15px]">
              {NAV.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    data-testid={`footer-nav-${item.label.toLowerCase()}`}
                    className="hover:text-white transition-colors"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="mt-10">
              <p className="text-[11px] uppercase tracking-[0.25em] text-[#79836B] mb-4">
                Write to us
              </p>
              <a
                href="mailto:sales@saafi.co.in"
                className="inline-flex items-center gap-2 text-[15px] hover:text-white transition-colors"
                data-testid="footer-email-link"
              >
                sales@saafi.co.in
                <ArrowUpRight className="w-4 h-4" strokeWidth={1.75} />
              </a>
            </div>
          </div>
        </div>

        <div className="h-px bg-[#313632] my-14" />

        <div className="flex flex-col gap-4 text-[12px] text-[#79836B]">
          <p data-testid="footer-legal">
            Saafi Industries Private Limited | Pune, Maharashtra | CIN U74999PN2022PTC211901
          </p>
          <div className="flex flex-wrap items-center justify-between gap-4">
            <p>© {new Date().getFullYear()} Saafi Industries. All rights reserved.</p>
            <div className="flex items-center gap-6">
              <span className="hidden md:inline">Privacy</span>
              <span className="hidden md:inline">Terms</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
